module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza20211.a260d6cd.jpg";